<template>
  <NuxtLink
    class="comparison-card"
    :to="to"
  >
    <UiComponentParagraph
      class="software"
      :style="{ color: firstSoftware.color }"
    >
      {{
        firstSoftware.name
      }}
    </UiComponentParagraph>
    <div class="vs">
      vs
    </div>
    <UiComponentParagraph
      class="software"
      :style="{ color: secondSoftware.color }"
    >
      {{
        secondSoftware.name
      }}
    </UiComponentParagraph>
  </NuxtLink>
</template>

<script setup>
// Composables
const localePath = useLocalePath()

// Props
const props = defineProps({
  firstSoftware: {
    required: true,
    type: Object,
  },
  secondSoftware: {
    required: true,
    type: Object,
  },
  slug: {
    required: true,
    type: String,
  },
})

// Computed Properties
const title = computed(() => {
  return `${props.firstSoftware.name} vs ${props.secondSoftware.name}`
})

const to = computed(() => {
  return localePath({
    name: 'webinar-software-comparison-slug',
    params: {
      slug: props.slug,
    },
  })
})
</script>

<style lang="postcss" scoped>
.comparison-card {
  height: 148px;
  @apply flex flex-col items-center justify-center border-2 border-grey-blue-200 rounded-[24px] transition ease-in-out duration-300;

  @screen md {
    height: 196px;
  }

  &:hover {
    @apply shadow-xl;
  }

  .vs {
    border-radius: 8px;
    width: 28px;
    height: 28px;
    @apply my-2 flex justify-center items-center text-sm text-grey-blue-400 font-medium border-2 border-grey-blue-200;

    @screen md {
      @apply my-5;
    }
  }

  .software {
    @apply font-medium;
  }
}
</style>
